const splitIntoLines = (element) => {
  if (window.SplitText) {
    gsap.registerPlugin(SplitText);
    
    const split = SplitText.create(element, {
      type: "lines",
      linesClass: "block-line++",
      lineThreshold: 0.1,
    });

    const lines = split.lines;
    
    // Wrap each line and return
    lines.forEach((line) => {
      const wrapper = document.createElement("div");
      wrapper.className = "block-line-wrapper";
      line.parentNode.insertBefore(wrapper, line);
      wrapper.appendChild(line);
    });
    
    return lines;
  }

  return [];
};

const initTextBlockReveal = () => {
  if (!window.gsap) return;
  
  gsap.registerPlugin(ScrollTrigger);
  
  // Defer layout reads to avoid forced reflow
  requestAnimationFrame(() => {
    const isMobile = window.innerWidth < 768;
    const isDesignMode = window.Shopify?.designMode;
    
    document.querySelectorAll('[data-text-block-reveal]').forEach(element => {
      // Skip animation in theme editor or on mobile
      if (isDesignMode || isMobile) {
        gsap.set(element, { opacity: 1 });
        return;
      }

    // Get options from data attributes
    const blockColor = element.getAttribute('data-block-color') || 'var(--color-background)';
    const stagger = parseFloat(element.getAttribute('data-stagger')) || 0.15;
    const duration = parseFloat(element.getAttribute('data-duration')) || 0.75;
    const delay = parseFloat(element.getAttribute('data-delay')) || 0;
    const animateOnScroll = element.getAttribute('data-animate-on-scroll') !== 'false';

    // Split text into lines
    const lines = splitIntoLines(element);
    if (lines.length === 0) return;

    const blocks = [];

    // Add block revealer to each line wrapper
    lines.forEach((line) => {
      const wrapper = line.parentElement;
      const block = document.createElement("div");
      block.className = "block-revealer";
      block.style.backgroundColor = blockColor;
      wrapper.appendChild(block);
      blocks.push(block);
    });

    // Set initial states
    gsap.set(lines, { opacity: 0 });
    gsap.set(blocks, { scaleX: 0, transformOrigin: "left center" });
    gsap.set(element, { opacity: 1 });

    // Create animation function
    const createBlockRevealAnimation = (block, line, index) => {
      const tl = gsap.timeline({ delay: delay + index * stagger });

      tl.to(block, { 
        scaleX: 1, 
        duration: duration, 
        ease: "power4.inOut" 
      });
      tl.set(line, { opacity: 1 });
      tl.set(block, { transformOrigin: "right center" });
      tl.to(block, { 
        scaleX: 0, 
        duration: duration, 
        ease: "power4.inOut" 
      });

      return tl;
    };

    // Animate on scroll or immediately
    if (animateOnScroll) {
      blocks.forEach((block, index) => {
        const tl = createBlockRevealAnimation(block, lines[index], index);
        tl.pause();

        ScrollTrigger.create({
          trigger: element,
          start: "top 90%",
          once: true,
          onEnter: () => tl.play(),
        });
      });
    } else {
      blocks.forEach((block, index) => {
        createBlockRevealAnimation(block, lines[index], index);
      });
    } 
    });
  });
};

// Wait for GSAP to load
const checkGSAPTextReveal = setInterval(() => {
  if (window.gsap) {
    clearInterval(checkGSAPTextReveal);
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTextBlockReveal);
    } else {
      initTextBlockReveal();
    }
  }
}, 50);

// Timeout after 5 seconds
setTimeout(() => clearInterval(checkGSAPTextReveal), 5000);